"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderWorkspacePicker = exports.CoreHeaderWorkspacePicker = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var HeaderWorkspacePickerButton_1 = require("./HeaderWorkspacePickerButton");
var HeaderWorkspacePickerItem_1 = require("./HeaderWorkspacePickerItem");
var Dropdown_1 = require("../Dropdown");
var NoData_1 = require("../NoData");
var renderProjectPickerFooter = function (projectPickerFooter) {
    var comp = function (closeDropdown) {
        return projectPickerFooter ? (react_1.default.createElement("div", { className: "gd-header-project-picker-footer" },
            react_1.default.createElement("span", { onClick: closeDropdown }, projectPickerFooter))) : (false);
    };
    comp.displayName = "ProjectPickerFooter";
    return comp;
};
exports.CoreHeaderWorkspacePicker = function (_a) {
    var _b;
    var intl = _a.intl, isLoading = _a.isLoading, workspaces = _a.workspaces, selectedWorkspace = _a.selectedWorkspace, totalWorkspacesCount = _a.totalWorkspacesCount, searchString = _a.searchString, showSearch = _a.showSearch, onOpen = _a.onOpen, onSelect = _a.onSelect, onSearch = _a.onSearch, onScrollEnd = _a.onScrollEnd, projectPickerFooter = _a.projectPickerFooter, className = _a.className, isRenamingProjectToWorkspaceEnabled = _a.isRenamingProjectToWorkspaceEnabled;
    var t = intl.formatMessage;
    var dropdownClassNames = classnames_1.default((_b = {
            "gd-header-project-wrapper": true,
            "gd-header-measure": true
        },
        _b[className] = !!className,
        _b));
    var noMatchingWorkspacesId = isRenamingProjectToWorkspaceEnabled
        ? "gs.header.projectPicker.noMatchingWorkspaces"
        : "gs.header.projectPicker.noMatchingProjects";
    return (react_1.default.createElement(Dropdown_1.Dropdown, { className: dropdownClassNames, closeOnParentScroll: true, closeOnMouseDrag: true, onOpenStateChanged: function (isOpen) {
            if (isOpen && onOpen) {
                onOpen();
            }
        }, renderButton: function (_a) {
            var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
            return (react_1.default.createElement(HeaderWorkspacePickerButton_1.HeaderWorkspacePickerButton, { title: selectedWorkspace && selectedWorkspace.title, isOpen: isOpen, onClick: toggleDropdown }));
        }, renderBody: function (_a) {
            var closeDropdown = _a.closeDropdown, isMobile = _a.isMobile;
            return (react_1.default.createElement(Dropdown_1.DropdownList, { footer: renderProjectPickerFooter(projectPickerFooter), closeDropdown: closeDropdown, className: "project-picker-dropdown", width: 350, isMobile: isMobile, showSearch: showSearch, searchString: searchString, items: workspaces, itemsCount: totalWorkspacesCount, isLoading: isLoading, onSearch: onSearch, searchFieldSize: "normal", searchPlaceholder: t({ id: "gs.header.projectPicker.searchPlaceholder" }), renderNoData: function (_a) {
                    var hasNoMatchingData = _a.hasNoMatchingData;
                    return (react_1.default.createElement(NoData_1.NoData, { className: "s-noMatchingProjects", noDataLabel: t({ id: "gs.noData.noDataAvailable" }), notFoundLabel: t({ id: noMatchingWorkspacesId }), hasNoMatchingData: hasNoMatchingData }));
                }, renderItem: function (_a) {
                    var item = _a.item;
                    var title = item === null || item === void 0 ? void 0 : item.title;
                    var isDemo = item === null || item === void 0 ? void 0 : item.isDemo;
                    var isSelected = selectedWorkspace && item && selectedWorkspace.id === item.id;
                    return (react_1.default.createElement(HeaderWorkspacePickerItem_1.HeaderWorkspacePickerItem, { title: title, isDemo: isDemo, isSelected: isSelected, isLoading: !item, onClick: function () {
                            if (item && onSelect) {
                                onSelect(item);
                                closeDropdown();
                            }
                        } }));
                }, onScrollEnd: onScrollEnd }));
        } }));
};
/**
 * @internal
 */
exports.HeaderWorkspacePicker = react_intl_1.injectIntl(exports.CoreHeaderWorkspacePicker);
//# sourceMappingURL=HeaderWorkspacePicker.js.map